import {BdLRUCacheNode} from "./lru-cache-node";

export class BdLRUCache {

  private size: number = 0;
  private map: { [key: string]: BdLRUCacheNode } = {};
  private head: BdLRUCacheNode = null;
  private tail: BdLRUCacheNode = null;

  constructor(
    public limit: number = 10
  ) {
  }

  public setHead(toSet: BdLRUCacheNode) {
    toSet.next = this.head;
    toSet.prev = null;

    if (this.head !== null) {
      this.head.prev = toSet;
    }

    this.head = toSet;

    if (this.tail === null) {
      this.tail = toSet;
    }

    this.size++;
    this.map[toSet.key] = toSet;
  }

  public set(key: string, value: unknown) {
    const node = new BdLRUCacheNode(key, value);

    if (this.map[key]) {
      this.map[key].value = node.value;
      this.remove(node.key);
    } else {
      if (this.size >= this.limit) {
        delete this.map[this.tail.key];
        this.size--;
        this.tail = this.tail.prev;
        this.tail.next = null;
      }
    }

    this.setHead(node);
  }

  /**
   * Retrieves the object from the cache by given key.
   * Returns null if key doesn't exist on cache.
   */
  public get(key: string): unknown | null {
    let value = null;

    if (this.map[key]) {
      value = this.map[key].value;
      const node = new BdLRUCacheNode(key, value);

      this.remove(key);
      this.setHead(node);
    }

    return value;
  }

  public remove(key: string) {
    const node = this.map[key];

    if (node.prev !== null) {
      node.prev.next = node.next;
    } else {
      this.head = node.next;
    }

    if (node.next !== null) {
      node.next.prev = node.prev;
    } else {
      this.tail = node.prev;
    }

    delete this.map[key];
    this.size--;
  }
}
